/**
 * Metodo que permite ejecutar una función `callback` para cada property del view.
 * Recorre el view recursivamente.
 *
 * @example flatmap(view, (property, parent) => {...})
 *
 * @param {View} property el view completo
 * @param {Function} callback el metodo que se lanzara para cada property, ej. `callback(property, parentProperty)`
 */
export function flatmap(property, callback) {
  if (Array.isArray(property?.properties)) {
    property.properties.forEach(childProperty => {
      callback(childProperty, property);
      flatmap(childProperty, callback);
    });
  }
}
